<template>
  <div>
    <v-row>
      <!--end of title-->
      <v-col cols="3" xl="3" lg="3" md="6" sm="6">
        <div class="mb-3 font-weight-bold">
          {{$t('pages.agreementConclusionChangeOwner.passport')}}
        </div>
        <ol v-if="formData && formData.document">
          <li><b>ФИО:</b> {{ userName }}</li>
          <li><b>{{$t('pages.agreementConclusionChangeOwner.typeDocument')}}:</b> Паспорт</li>
          <li>
            <b>{{$t('pages.agreementConclusionChangeOwner.documentSeries')}}:</b>
            {{ formData.document.series | emptyMessage(notExist) }}
          </li>
          <li>
            <b>{{$t('pages.agreementConclusionChangeOwner.documentNumber')}}:</b>
            {{ formData.document.number | emptyMessage(notExist)  }}
          </li>
          <li>
            <b>{{$t('pages.agreementConclusionChangeOwner.issuedPassport')}}:</b>
            {{ formData.document.issuer | emptyMessage(notExist)  }}
          </li>
          <li>
            <b>{{$t('pages.agreementConclusionChangeOwner.dateIssue')}}:</b>
            {{ formData.document.issueDate | humanReadableDate(notExist) }}
          </li>
          <li>
            <b>{{$t('pages.agreementConclusionChangeOwner.departamentCode')}}:</b>
            {{ formData.document.unitCode | emptyMessage(notExist)  }}
          </li>
          <li>
            <b>{{$t('pages.agreementConclusionChangeOwner.dateBirth')}}:</b>
            {{ formData.document.birthDate | humanReadableDate(notExist) }}
          </li>
          <li>
            <b>{{$t('pages.agreementConclusionChangeOwner.placeBirth')}}:</b>
            {{ formData.document.birthPlace | emptyMessage(notExist)  }}
          </li>
          <li>
            <b>ИНН:</b>
            {{ formData.document.inn | emptyMessage(notExist)  }}
          </li>
          <li>
            <b>СНИЛС:</b>
            {{ formData.document.snils | emptyMessage(notExist)  }}
          </li>
          <li>
            <b>{{$t('pages.agreementConclusionChangeOwner.phone')}}:</b>
            {{ formData.document.phone | emptyMessage(notExist)  }}
          </li>
        </ol>
      </v-col>

      <v-col cols="3" xl="3" lg="3" md="6" sm="6">
        <div class="mb-3 font-weight-bold">{{$t('pages.agreementConclusionChangeOwner.regAddress')}}</div>
          <ol v-if="formData.regAddress">
          <li>
            <b>Адрес:</b>
            {{
              formData.regAddress
                | emptyMessage(notExist) 
            }}
          </li>
          </ol>
        <div class="mb-3 mt-6 font-weight-bold">{{$t('pages.agreementConclusionChangeOwner.objectInfo')}}</div>
        <ol v-if="formData.BuildingType">
          <li>
            <b>{{$t('pages.agreementConclusionChangeOwner.typeBuilding')}}:</b>
            {{
              buildItems.find((it) => it.type === formData.BuildingType).text
                | emptyMessage(notExist) 
            }}
          </li>
          <li>
            <b>{{$t('pages.agreementConclusionChangeOwner.square')}}:</b>
            {{ formData.totalArea | emptyMessage(notExist) }}
          </li>
          <li>
            <b>{{$t('pages.agreementConclusionChangeOwner.floors')}}:</b>
            {{ formData.floor | emptyMessage(notExist)  }}
          </li>
          <li>
            <b>{{$t('pages.agreementConclusionChangeOwner.rooms')}}:</b>
            {{ formData.numberRooms | emptyMessage(notExist)  }}
          </li>
          <li>
            <b>{{$t('pages.agreementConclusionChangeOwner.residents')}}:</b>
            {{ formData.numberInhabitants | emptyMessage(notExist)  }}
          </li>
          <li>
            <b>{{$t('pages.agreementConclusionChangeOwner.cadastre')}}:</b>
            {{ formData.cadastralNumber | emptyMessage(notExist) }}
          </li>
        </ol>
      </v-col>
      <v-col cols="6" xl="6" lg="6" md="12" sm="12" v-if="formData.principals">
        <div class="border-col">
        <span class="elements-line">
          <v-checkbox color="success" v-model="formData.agreeContract" />
          <span class="fs-11">Руководствуясь ст. 9 Федерального закона от 27.07.2006 №152-ФЗ "О персональных данных" даю согласие   АО «Татэнергосбыт», находящемуся по адресу: г. Казань, ул. Павлюхина 110В, ИНН 1657082308, ОГРН 1091690003481 (далее Оператор), на обработку моих персональных данных с целью переоформления лицевого счета, направления информации в адрес исполнителей жилищно-коммунальных услуг и прочих организаций, осуществляющих деятельность в сфере жилищно-коммунальных услуг. </span>
        </span>   
  <table border="1" class="table">
    <thead>
      <tr>
        <th>{{ leftHeader.default }}</th>
        <th>{{ rightHeader.default }}</th>
      </tr>
    </thead>
    <tbody>
      <template v-if="formData.principals.length === 0">
        <tr>
          <td>Нет данных</td>
          <td :rowspan="1">
            <slot name="big-cell">Пустая ячейка</slot>
          </td>
        </tr>
      </template>

      <!-- Обычное отображение -->
      <template v-else>
        <tr v-for="(item, index) in formData.principals" :key="item.name + Math.random()">
          <td>{{item.name}},{{item.info}}</td>
          
          <td v-if="index === 0" :rowspan="formData.principals.length">
            <slot name="big-cell">фамилия, имя, отчество, дата рождения, паспортные данные (серия, номер, наименование выдавшего подразделения, код подразделения, дата выдачи), место рождения, фото, адрес регистрации по месту жительства, сведения о государственной регистрации права, СНИЛС, ИНН.</slot>
          </td>
        </tr>
      </template>
    </tbody>
  </table>
      </div>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import {mapState} from "vuex";

export default {
  props: ["income"],
  data: () => ({
  leftHeader: {
      type: String,
      default: "Наименование и адрес исполнителя жилищно-коммунальных услуг",
    },
  rightHeader: {
      type: String,
      default: "Категории персональных данных",
    },
  formData: {},
    // FORM SETTINGS
    dataIsValid: true, // Важное поле для работы визарда
  }),
  computed: {
    userName() {
      return this.$store.state.account.userSettings.name;
    },
    registrationsAddress() {
      return this.formData.addresses.find(
        (item) => String(item.addressType) === "802740000"
        // item => item.addressType === "802740000"
      );
    },
    residenceAddress() {
      if (this.formData.isEqualRegAddress) {
        return this.registrationsAddress || {};
      } else {
        return (
          this.formData.addresses.find(
            (item) => item.addressType === "802740003"
          ) || {}
        );
      }
    },
    deliveryAddress() {
      if (this.formData.isEqualResAddress) {
        return this.residenceAddress || {};
      } else {
        return (
          this.formData.addresses.find(
            (item) => String(item.addressType) === "802740001"
          ) || {}
        );
      }
    },
    objectAddress() {
      if (this.formData.addresses) {
        return this.formData.addresses.find(
          (item) => String(item.addressType) === "802740002"
        );
      }
    },
    buildItems() {
        return [
      {
        text: this.$t('pages.agreementConclusionChangeOwner.bathHouse'),
        type: "802740004",
      },
      {
        text: this.$t('pages.agreementConclusionChangeOwner.garage'),
        type: "802740003",
      },
      {
        text: this.$t('pages.agreementConclusionChangeOwner.landPlot'),
        type: "802740002",
      },
      {
        text: this.$t('pages.agreementConclusionChangeOwner.flat'),
        type: "802740001",
      },
      {
        text: this.$t('pages.agreementConclusionChangeOwner.room'),
        type: "802740008",
      },
      {
        text: this.$t('pages.agreementConclusionChangeOwner.gardenHouse'),
        type: "802740007",
      },
      {
        text: this.$t('pages.agreementConclusionChangeOwner.barn'),
        type: "802740005",
      },
      {
        text: this.$t('pages.agreementConclusionChangeOwner.privateHouse'),
        type: "802740000",
      },
      {
        text: this.$t('pages.agreementConclusionChangeOwner.detachedGarage'),
        type: "802740006",
      },
    ]
    },
    notExist(){return this.$t('pages.agreementConclusionChangeOwner.notSpecified')}
  },
  methods: {
    transferData() {
      // DATA
      this.$emit("transfer", null);
    },
  },
  created() {
    this.transferData();
    this.formData = this.income;
  },
  filters: {
    emptyMessage: (val, notExist) => (val ? val : notExist),
    humanReadableDate: (val, notExist) => {
      return val
        ? new Date(val).toLocaleString("ru", {
            day: "numeric",
            month: "short",
            year: "numeric",
          })
        : notExist;
    },
  },
  watch: {
    income: {
      immediate: true,
      handler: function (value) {
        this.formData = value;
      },
    },
  },
};
</script>
<style> 
.elements-line  {
  display: flex;
  align-items: center;
  gap: 6px;
  margin: 3%;
}
.border-col{
  border: 1px solid black;
  margin-bottom: 10px;
  overflow: auto;
  width: 100%;
}
.table{
  border-collapse: collapse; 
  margin: 1%;
  font-size: 12px;
}
.table th, .table td{
  padding: 1%;
}
</style>
